import React from 'react'
import Zoom from '../common/zoom'


function ZoomB(props) {
  return (
    <Zoom
      {...props}
      poster="https://volverse-negro-daniel.s3.amazonaws.com/stills/zoom-2.jpg"
      src="https://volverse-negro-daniel.s3.amazonaws.com/videos/zoom-2.mp4"
    />
  )
}


export default ZoomB
